import { useEffect } from "react";

/**
 * Client-side redirect for retired routes.
 * Used because CRA static hosting can't emit server-level 301s.
 * Renders a minimal fallback for the split-second before window.location swaps.
 */
const ExternalRedirect = ({ to }) => {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return (
    <div className="min-h-screen bg-[var(--bg-deep)] text-white flex items-center justify-center">
      <p className="text-sm text-[var(--text-muted)]">Redirecting to feeds.letspickquick.com...</p>
    </div>
  );
};

export default ExternalRedirect;
